import {
  defaultLifeCycle,
  states,
  saveStates,
  readStates,
  destroyStates,
  subscribeStates,
} from '@/constants/lifecycle';

const datasetActions = {
  CLOSE_DATASET: 'CLOSE_DATASET',
  CLOSE_DATASETS: 'CLOSE_DATASETS',
  CONVERT_TO_DICTIONARY: 'CONVERT_TO_DICTIONARY',
  CONVERT_TO_DICTIONARY_ERROR: 'CONVERT_TO_DICTIONARY_ERROR',
  CONVERT_TO_DICTIONARY_SUCCESS: 'CONVERT_TO_DICTIONARY_SUCCESS',
  CREATE_ACTIVE_DATASET: 'CREATE_ACTIVE_DATASET',
  CREATE_AND_CONVERT_TO_DICTIONARY: 'CREATE_AND_CONVERT_TO_DICTIONARY',
  CREATE_DATASET: 'CREATE_DATASET',
  DATASET_SETTINGS_CHANGED: 'DATASET_SETTINGS_CHANGED',
  DELETE_DATASET: 'DELETE_DATASET',
  DESTROY_DATASET: 'DESTROY_DATASET',
  DESTROY_DATASET_ERROR: 'DESTROY_DATASET_ERROR',
  DOWNLOAD_DATASET: 'DOWNLOAD_DATASET',
  DOWNLOAD_DATASET_ERROR: 'DOWNLOAD_DATASET_ERROR',
  EDIT_DATASET: 'EDIT_DATASET',
  ENABLE_PMN_TRANSFERS: 'ENABLE_PMN_TRANSFERS',
  FETCH_DATASET: 'FETCH_DATASET',
  FETCH_DATASETS: 'FETCH_DATASETS',
  FINISH_DATASET_WIZARD: 'FINISH_DATASET_WIZARD',
  HIDE_DELETE_DATASET: 'HIDE_DELETE_DATASET',
  HIDE_SAVE_DATASET: 'HIDE_SAVE_DATASET',
  NEW_DATASET: 'NEW_DATASET',
  NEW_DATASET_ERROR: 'NEW_DATASET_ERROR',
  NEW_DATASET_FROM_SOURCE: 'NEW_DATASET_FROM_SOURCE',
  NEW_DICTIONARY_ERROR: 'NEW_DICTIONARY_ERROR',
  NEW_DICTIONARY_SUCCESS: 'NEW_DICTIONARY_SUCCESS',
  REFRESH_DATASET_SETTINGS: 'REFRESH_DATASET_SETTINGS',
  REFRESH_DATASETS: 'REFRESH_DATASETS',
  SHOW_CLONE_DATASET: 'SHOW_CLONE_DATASET',
  SHOW_DATASET: 'SHOW_DATASET',
  SHOW_DATASET_ERROR: 'SHOW_DATASET_ERROR',
  SHOW_DATASETS_ERROR: 'SHOW_DATASETS_ERROR',
  SHOW_DATASETS_RESULTS: 'SHOW_DATASETS_RESULTS',
  SHOW_DELETE_DATASET: 'SHOW_DELETE_DATASET',
  SHOW_DELETE_DATASETS: 'SHOW_DELETE_DATASETS',
  SHOW_NEW_DATASET: 'SHOW_NEW_DATASET',
  SHOW_SAVE_DATASET: 'SHOW_SAVE_DATASET',
  TOGGLE_DATASET_COLUMN_ORDER_BY: 'TOGGLE_DATASET_COLUMN_ORDER_BY',
  TOGGLE_DATASET_SELECTED: 'TOGGLE_DATASET_SELECTED',
  TOGGLE_DATASET_PREVIEW: 'TOGGLE_DATASET_PREVIEW',
  TOGGLE_DATASET_SINGLE_SORTING: 'TOGGLE_DATASET_SINGLE_SORTING',
  TOGGLE_DATASET_WIZARD: 'TOGGLE_DATASET_WIZARD',
  TOGGLE_DATASETS_SELECTED: 'TOGGLE_DATASETS_SELECTED',
  UPDATE_ACTIVE_DATASET_PROPERTIES: 'UPDATE_ACTIVE_DATASET_PROPERTIES',
  UPDATE_CURRENT_DATASET_PERMISSIONS: 'UPDATE_CURRENT_DATASET_PERMISSIONS',
  UPDATE_DATASET: 'UPDATE_DATASET',
  UPDATE_DATASET_CANCEL: 'UPDATE_DATASET_CANCEL',
  UPDATE_DATASET_CATALOGUE: 'UPDATE_DATASET_CATALOGUE',
  UPDATE_DATASET_CATALOGUE_SUCCESS: 'UPDATE_DATASET_CATALOGUE_SUCCESS',
  UPDATE_DATASET_ERROR: 'UPDATE_DATASET_ERROR',
  UPDATE_DATASET_PROPERTIES: 'UPDATE_DATASET_PROPERTIES',
  UPDATE_DATASET_STEP: 'UPDATE_DATASET_STEP',
  UPDATE_DATASET_SUCCESS: 'UPDATE_DATASET_SUCCESS',
  UPDATE_DATASET_VALIDATION_ERRORS: 'UPDATE_DATASET_VALIDATION_ERRORS',
  UPDATE_DATASETS_FILTER: 'UPDATE_DATASETS_FILTER',
  UPDATE_DATASETS_FLAGS: 'UPDATE_DATASETS_FLAGS',
  UPDATE_DATASETS_DATA_MODEL_FILTER: 'UPDATE_DATASETS_DATA_MODEL_FILTER',
  TOGGLE_DATASETS_PRESENTATION: 'TOGGLE_DATASETS_PRESENTATION',
};

export const datasetCatalogueActions = {
  UPDATE_CATALOGUE_PANELS: 'UPDATE_CATALOGUE_PANELS',
  UPDATE_DATASET_CATALOGUE_PROPERTIES: 'UPDATE_DATASET_CATALOGUE_PROPERTIES',
  UPDATE_DATASET_CATALOGUE_TITLE: 'UPDATE_DATASET_CATALOGUE_TITLE',
};

export const datasetLists = ['all', 'ribbon'];

export const datasetCategories = [...datasetLists, 'open', 'deletion', 'dataManagement'];

export const datasetLifeCycle = [
  ...defaultLifeCycle,
];

export const datasetStates = {
  ...readStates,
  ...saveStates,
  ...destroyStates,
  uploadStatus: states.NONE,
  uploadErrors: [],
  ...subscribeStates,
};

export const lookupFieldTypes = [
  'date',
  'decimal',
  'integer',
  'text',
  'time',
];

export const DATASET_RIBBON_ITEMS_LENGTH = 9;

export const datasetCatalogueSteps = {
  FIRST_SECTION: { name: 'first', icon: 'chevron right', isSection: true },
  SECOND_SECTION: { name: 'second', icon: 'chevron right', isSection: true },
  THIRD_SECTION: { name: 'third', icon: 'chevron right', isSection: true },
};

export const datasetStartStep = { START: { name: 'select_dataset_type', icon: 'bullseye' } };
export const datasetDictionariesStep = { DICTIONARIES: { name: 'dictionaries', icon: 'table' } };
export const datasetSettingsStep = { SETTINGS: { name: 'settings', icon: 'sliders' } };

const datasetPostCatalogueSteps = {
  ATTACHMENTS: { name: 'attachments', icon: 'paperclip' },
  ...datasetDictionariesStep,
  ...datasetSettingsStep,
};

export const datasetStepsWithCatalogue = {
  ...datasetStartStep,
  ...datasetPostCatalogueSteps,
};

export const datasetSteps = {
  ...datasetStartStep,
  CATALOGUE_PLACEHOLDER: { name: 'catalogue', icon: 'chevron right' },
  ...datasetCatalogueSteps,
  ...datasetPostCatalogueSteps,
};

export const datasetSourceEntities = {
  DATASET: 'dataset',
  TEMPLATE: 'catalogue-template',
};

export default datasetActions;
